import { purchaseTrackingManagerMachineContext } from '.'
import { useSyncMachineWithArtBlocksClient } from '@/hooks/use-sync-machine-with-artblocks-client'
import { useArtBlocksClient } from '@components/artblocks-provider'
import { ReactElement } from 'react'

export function PurchaseTrackingManagerMachineProvider({ children }: { children: React.ReactNode }): ReactElement {
  const artblocksClient = useArtBlocksClient()

  return (
    <purchaseTrackingManagerMachineContext.Provider
      options={{
        input: { artblocksClient }
      }}
    >
      <PurchaseTrackingManagerMachineManager />
      {children}
    </purchaseTrackingManagerMachineContext.Provider>
  )
}

function PurchaseTrackingManagerMachineManager() {
  const managerMachineRef = purchaseTrackingManagerMachineContext.useActorRef()
  useSyncMachineWithArtBlocksClient(managerMachineRef)

  return null
}
